import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        main: '#101B24',
        primary: '#4BB27C',
        secondary: '#E3f6EC',
        accent: '#82B1FF',
        error: '#FF9292',
        info: '#9E9E9E',
        success: '#4CAF50',
        warning: '#FFC107',
      }
    }
  }
});
